// color design tokens export
// main_bg: #191e44 side_nav: #20295d
export const tokensDark = {
  grey: {
    0: "#ffffff",
    10: "#f6f6f6",
    50: "#f0f0f0",
    100: "#e0e0e0",
    200: "#c2c2c2",
    300: "#a3a3a3",
    400: "#858585",
    500: "#666666",
    600: "#525252",
    700: "#3d3d3d",
    800: "#292929",
    900: "#141414",
    1000: "#000000", // manually adjusted
  },
  primary: {
    // blue
    50: "#fff", //white
    100: "#d3d4de",
    200: "#a6a9be",
    300: "#7a7f9d",
    400: "#4d547d",
    500: "#21295c", // color of the table
    600: "#191F45",
    700: "#141937",
    800: "#0d1025",
    900: "#070812",
    101: "#2A0F41", //gray
    102: "#1e0a2f", //dark
    103: "#00c9a7", //success
    104: "#24baef", //cyan
    105: "#24baef", //info
    106: "#8b0606", //rodhi button1
    106: "#900303d4", //rodhi button2
    106: "#8b060689", //rodhi button3
  },
  // "#150920", //gray
  //   102: "#2A0F41", //dark
  // 6e34a1
  secondary: {
    // yellow
    50: "#f0f0f0", // manually adjusted
    100: "#fff6e0",
    200: "#ffedc2",
    // 300: "#ffe3a3",
    300: "#2A0F41", //maroon of the sub-title and side bar acive color
    400: "#ffda85",
    500: "#ffd166",
    600: "#cca752",
    700: "#997d3d",
    800: "#665429",
    900: "#332a14",
    150: "#377dff", //blue
    250: "#a370d1", //red of the title
    350: "#6f42c1", //purple
    450: "#6e34a1", //navy
  },
  custom: {
    // mix
    50: "#377dff", //blue
    100: "#28a745", //green
    200: "#6f42c1", //purple
    300: "#de4437", //red
    400: "#24baef", //info
    500: "#21325b", //navy
    600: "#00c9a7", //success
    700: "#f5ca99", //warning
    800: "#fff", //white
    900: "#24baef", //cyan
  },
  // rodhiflix: {
  // blue: "#377dff",
  // indigo: '#2d1582',
  // purple: '#6f42c1',
  // pink: '#e83e8c',
  // red: '#de4437',
  // orange: '#fd7e14',
  // yellow: '#f5ca99',
  // green: '#28a745',
  // teal: '#00c9a7',
  // cyan: '#24baef',
  // white: '#fff',
  // gray: '#8c98a4',
  // darkgray: '#495057',
  // primeblue: '#24baef',
  // second: '#495057',
  // success: '#00c9a7',
  // info: '#24baef',
  // warning: '#f5ca99',
  // danger: '#de4437',
  // light: '#f7faff',
  // dark: '#19272e',
  // indigo: '#2d1582',
  // white: '#fff',
  // navy: '#21325b',
  // },
};

// function that reverses the color palette
function reverseTokens(tokensDark) {
  const reversedTokens = {};
  Object.entries(tokensDark).forEach(([key, val]) => {
    const keys = Object.keys(val);
    const values = Object.values(val);
    const length = keys.length;
    const reversedObj = {};
    for (let i = 0; i < length; i++) {
      reversedObj[keys[i]] = values[length - i - 1];
    }
    reversedTokens[key] = reversedObj;
  });
  return reversedTokens;
}
export const tokensLight = reverseTokens(tokensDark);

// mui theme settings
export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              ...tokensDark.primary,
              main: tokensDark.primary[400],
              light: tokensDark.primary[400],
            },
            secondary: {
              ...tokensDark.secondary,
              main: tokensDark.secondary[300],
            },
            custom: {
              ...tokensDark.custom,
              main: tokensDark.custom[300],
            },
            neutral: {
              ...tokensDark.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.primary[102],
              alt: tokensDark.primary[101],
            },
          }
        : {
            // palette values for light mode
            primary: {
              ...tokensLight.primary,
              main: tokensDark.grey[50],
              light: tokensDark.grey[100],
            },
            secondary: {
              ...tokensLight.secondary,
              main: tokensDark.secondary[600],
              light: tokensDark.secondary[700],
            },
            custom: {
              ...tokensLight.custom,
              main: tokensDark.custom[800],
              light: tokensDark.custom[900],
            },
            neutral: {
              ...tokensLight.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.grey[0],
              alt: tokensDark.grey[50],
            },
          }),
    },
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
  };
};
